import { createFileRoute } from '@tanstack/react-router';

import { AnalyticsPage } from '../../../analytics/AnalyticsPage.js';
import { usePermissions } from '../../../api/me.js';
import { PageHeading } from '../../../components/PageHeading.js';
import { PermissionDeniedPage } from '../../../components/SectionStates.js';

/**
 * `/account/analytics`: the Overview, analytics for every website in the
 * account together, and each website compared. It belongs to the account,
 * not to one website, and needs the analytics permission.
 */
export const Route = createFileRoute('/_app/account/analytics')({
  component: OverviewRoute,
});

const TITLE = 'Overview';

function OverviewRoute() {
  const permissions = usePermissions();
  if (!permissions.includes('analytics')) {
    return <PermissionDeniedPage title={TITLE} permission="analytics" />;
  }
  return (
    <>
      <PageHeading documentTitle={TITLE}>{TITLE}</PageHeading>
      <AnalyticsPage />
    </>
  );
}
